<template>
    <div class="about" style="padding: 20px">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
        <h1>About Us Page</h1>
        <v-form
                enctype="multipart/form-data"
                ref="form"
                v-model="valid"
        >
            <v-tabs
                    :grow="true"
                    background-color="indigo"
                    dark
            >
                <v-tab @click="language='en'">English</v-tab>
                <v-tab @click="language='pt'">Portuguese</v-tab>
                <v-tab @click="language='es'">Spanish</v-tab>
            </v-tabs>
            <v-card
                    outlined
                    :loading="loading.general"
            >
                <v-card-text>
                    <v-row>
                        <!-- EN -->
                        <v-col
                                cols="12"
                                v-if="language=='en'"
                        >
                            <vue-editor v-model="dados.en"></vue-editor>
                        </v-col>
                        <!-- PT -->
                        <v-col
                                cols="12"
                                v-if="language=='pt'"
                        >
                            <vue-editor v-model="dados.pt"></vue-editor>
                        </v-col>
                        <!-- ES -->
                        <v-col
                                cols="12"
                                v-if="language=='es'"
                        >
                            <vue-editor v-model="dados.es"></vue-editor>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <br>
            <div v-if="erro">
                <v-alert type="error" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <div v-else>
                <v-alert type="success" dense outlined  v-for="(item,index) in msg" :key="index">
                    {{ item }}
                </v-alert>
            </div>
            <v-btn
                    v-if="loading.general == false"
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="validate"
            >
                Save
            </v-btn>
        </v-form>
    </div>
</template>
<script>
    import { VueEditor } from "vue2-editor";
    export default {
        components: {
            VueEditor
        },
        data: () => ({
            valid:true,
            loading:{
                general:true,
            },
            dados:{
                en:"",
                pt:"",
                es:"",
            },
            erro:true,
            msg:[],
            language:"en",
            breadcrumbs: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    to: '/',
                },
                {
                    text: 'About Us',
                    disabled: false,
                    to: '/about-us',
                },
            ],
        }),
        methods: {
            init(){
                this.$http.get("https://api.bestchoicevacation.com/pages/aboutUs",{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response =>{
                    this.loading.general = false;
                    this.dados.en = response.data.en;
                    this.dados.es = response.data.es;
                    this.dados.pt = response.data.pt;
                });
            },
            validate () {
                this.erro = false;
                var arr = JSON.stringify(this.dados);
                this.$http.post("https://api.bestchoicevacation.com/pages/aboutUs",arr,{
                    headers: {
                        'x-access-token': localStorage.hash
                    }
                }).then(response => {
                    this.loading.general = false;
                    this.msg = response.data.msg;
                    if(response.data.erro == '1'){
                        this.erro = true;
                    }
                });
            }
        },
        mounted(){
            this.init();
        }
    }
</script>